<template>
  <div>
    <div class="container">
      <header v-if="creation" class="create-offer-title">
        <div class="container">
          <div class="row">
            <div class="co-title-container gr-12 gr-8@desktop push-2@desktop gr-8@tablet-large gr-10@tablet">
              <h1>{{ trans('form.offer.setup_images.label') }}</h1>
              <!-- eslint-disable vue/no-v-html -->
              <span class="subtitle" v-html="trans('form.offer.setup_images.subtitle', { link: imageBlogLink })" />
            </div>
          </div>
        </div>
      </header>
      <cover v-model="coverUuid" :error="error" :validating="initIsValidatingCover" />
      <media-list
        v-if="coverUuid"
        v-model="mediasUuids"
        :validating-uuids="validatingUuids"
        @cover="switchCover"
        @edited="edited = true"
      />
    </div>

    <div v-if="creation" class="create-offer__sticky-cta">
      <div class="create-offer__submit">
        <div class="offer-creation-cta">
          <div>
            <button
              type="submit"
              name="setup[prev]"
              data-gtm="new-office-validation-setup_images"
              class="cancel btn btn--secondary"
            >
              <span>{{ trans('global.pagination.previous') }}</span>
            </button>
          </div>
          <div>
            <button
              type="button"
              data-gtm="new-office-validation-setup_images"
              class="next_step btn btn--primary"
              @click="submit"
            >
              <span>{{ trans('global.pagination.next') }}</span>
            </button>
            <input type="hidden" name="setup[next]" value="">
            <input type="hidden" name="setup[steps]" value="5">
          </div>
        </div>
      </div>
    </div>

    <div v-else class="create-offer__sticky-cta">
      <div class="create-offer__submit">
        <div class="offer-creation-cta edit">
          <div>
            <button
              type="button"
              class="btn btn--primary"
              :disabled="!edited"
              @click="submit"
            >
              <span>{{ trans('offer.save_all') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { trans } from '@elements/translation';
import Cover from './SetupImages/Cover.vue';
import MediaList from './SetupImages/MediaList.vue';

export default {
  components: { Cover, MediaList },
  props: {
    creation: { type: Boolean, default: false },
    initCoverUuid: { type: String, default: null },
    initMediasUuids: { type: String, default: null },
    initValidatingMediasUuids: { type: String, default: null },
    initIsValidatingCover: { type: Boolean, default: false },
    imageBlogLink: { type: String, required: true },
  },
  data() {
    return {
      edited: false,
      error: false,
      coverUuid: this.initCoverUuid,
      mediasUuids: this.initMediasUuids ? this.initMediasUuids.split(',') : [],
      validatingUuids: this.initValidatingMediasUuids ? this.initValidatingMediasUuids.split(',') : [],
    };
  },
  watch: {
    coverUuid() {
      this.edited = true;
    },
    mediasUuids: {
      deep: true,
      handler() {
        this.edited = true;
      },
    },
  },
  methods: {
    trans,
    switchCover(replaceIndex) {
      const oldCoverId = this.coverUuid;
      this.coverUuid = this.mediasUuids[replaceIndex];
      const newUuids = [];
      this.mediasUuids.forEach((uuid, index) => {
        if (index === replaceIndex) {
          newUuids.push(oldCoverId);
        } else {
          newUuids.push(uuid);
        }
      });
      this.mediasUuids = newUuids;
    },
    submit() {
      if (!this.coverUuid) {
        this.error = true;
        return false;
      }
      document.querySelector('form[name="setup"]').submit();
      return true;
    },
  },
};

</script>
